var cov_47a0ko2v2 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/EditableArea/index.ts",
      hash = "56cf1579483b3a27972dfac03402205e6253c278",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/EditableArea/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 10,
          column: 12
        }
      },
      "1": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 49
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import delay from '../hoc/delay';
import Component from './EditableArea';
import { compose } from '../utils/func';
import inputable from '../Form/inputable';
var EditableArea = (cov_47a0ko2v2.s[0]++, compose(inputable, delay(400))(Component));
cov_47a0ko2v2.s[1]++;
EditableArea.displayName = 'ShineoutEditableArea';
export default EditableArea;